import { useState } from "react";
import { EApproveStatus } from "../../types";
import { Tabs, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "../icons/ArrowLeft";
import { SeriesTab } from "../SeriesTab/SeriesTab";
import { EngineersTab } from "../EngineersTab/EngineersTab";
import { ContractorsTable } from "../ContractorsTable/ContractorsTable";
import {
  StyledBadge,
  StyledProjectTitle,
  StyledProjectWrapper,
  StyledTabs,
} from "./styled";

export const Project = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const dataTable = [
    {
      key: "1",
      contractor: "ООО Спецстрой",
      responsible: ["КЖ", "ОВ"],
      view: ["СГП"],
      phoneNumber: "+7 900 000-00-00",
      email: "info@specstroy.com",
    },
    {
      key: "2",
      contractor: "ООО Западстройинвест",
      responsible: ["КЖ"],
      view: ["ОВ"],
      phoneNumber: "+7 900 000-00-00",
      email: "nikolayev_director@zstroinvest.com",
    },
    {
      key: "3",
      contractor: "ИП Фирсов Евгений Никитич",
      responsible: ["СГП"],
      view: ["КЖ", "ОВ"],
      phoneNumber: "+7 900 000-00-00",
      email: "info@specstroy.com",
    },
  ];

  const [table, setTable] = useState(dataTable);

  const project = {
    id: "alximovo",
    title: "Алхимово",
    sections: [
      {
        key: "dfsdfff",
        title: "СГП1",
        status: EApproveStatus.UPDATED,
        date: "01.01.2023",
        sectionId: "sgp1",
        text: "Стройгенплан на здания на подготовительный период",
      },
      {
        key: "fdasef",
        title: "СГП2",
        status: EApproveStatus.UPDATED,
        date: "01.01.2023",
        sectionId: "sgp2",
        text: "Стройгенплан на здания на основной период",
      },
      {
        key: "hgregg",
        title: "ГП1",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "gp1",
        text: "Разбивочный план осей здания",
      },
      {
        key: "grgtg",
        title: "АР0",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "ap0",
        text: "Кладочные и маркировочные планы ниже отм. 0,000",
      },
      {
        key: "ftytyrty",
        title: "КЖ0.1.1",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "kj011",
        text: "Котлован",
      },
      {
        key: "lupulpj",
        title: "КЖ0.1.2",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "kj012",
        text: "Конструкции фундаментов",
      },
      {
        key: "dfwerwrf",
        title: "КЖ0.2",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "kj02",
        text: "Конструкции железобетонные ниже отм. 0,000",
      },
      {
        key: "rtytyuty",
        title: "КЖ0.3",
        status: EApproveStatus.ACTUAL,
        date: "01.01.2023",
        sectionId: "kj03",
        text: "Конструкции железобетонные лестниц подвала",
      },
    ],
    contractors: [],
    engeeners: [],
  };

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const projectTabs = [
    {
      title: "Разделы РД",
      key: "0",
      path: "series",
      noticesCount: 1,
      children: (
        <SeriesTab
          sections={project.sections}
          search={search}
          handleSearch={handleSearch}
        />
      ),
    },
    {
      title: "Инженеры ПТО",
      key: "1",
      path: "engineers",
      noticesCount: 0,
      children: <EngineersTab />,
    },
    {
      title: "Подрядчики",
      key: "2",
      path: "contractors",
      noticesCount: 0,
      children: (
        <ContractorsTable
          table={table}
          setTable={setTable}
          pagination={false}
        />
      ),
    },
  ];
  const [currentTab, setCurrentTab] = useState(projectTabs[0].path);

  const { id } = useParams<{ id: string | undefined }>();

  return (
    <StyledProjectWrapper>
      <StyledProjectTitle>
        <button
          style={{ border: "none", background: "none" }}
          onClick={() => navigate("/main/projects")}
        >
          <ArrowLeft />
        </button>
        <Typography.Title style={{ marginLeft: "14px" }} level={3}>
          {project.title}
        </Typography.Title>
      </StyledProjectTitle>

      <StyledTabs
        defaultActiveKey="0"
        size="small"
        onChange={(value) => setCurrentTab(value)}
      >
        {projectTabs.map((tab) => (
          <Tabs.TabPane
            key={tab.key}
            tab={
              <>
                {tab.title}
                <StyledBadge
                  size="small"
                  style={{
                    left: "10px",
                    width: "16px",
                    height: "16px",
                    fontSize: "12px",
                    borderRadius: "8px",
                    padding: "1px 0 0 0",
                  }}
                  count={tab.noticesCount}
                />
              </>
            }
            children={tab.children}
          />
        ))}
      </StyledTabs>
    </StyledProjectWrapper>
  );
};
